import { Box, Container, styled } from "@mui/material";
import logo from "../../assets/images/CrimeRisk.AI Final Logo.png";
import Loader from "../Loader";

const UnAuthedLayout = (props) => {
  const { children, width = "auto" } = props;
  return (
    <LayoutContainer maxWidth="sm">
      <LayoutPageOverlay />
      <LogoImage alt="crimeRisk Logo" src={logo} />
      <LoginFormContainer elevation={3} width={width}>
        {children}
      </LoginFormContainer>
    </LayoutContainer>
  );
};

const LayoutContainer = styled(Container)(() => ({
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  justifyContent: "center",
  minHeight: "100vh",
}));

const LayoutPageOverlay = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  backgroundColor: theme.palette.background.light,
  zIndex: -1,
}));

const LoginFormContainer = styled(Box)(({ theme, width }) => ({
  padding: "40px",
  borderRadius: "8px",
  border: `2px solid ${theme.palette.primary.main}`,
  backgroundColor: theme.palette.background.default,
  minWidth: "280px",
  boxShadow: `4px 5px 8px ${theme.palette.secondary.main}`,
  width,
  "@media (max-width: 700px)": {
    width: "auto",
  },
}));

const LogoImage = styled("img")(() => ({
  marginBottom: "24px",
  width: "250px",
}));

export default UnAuthedLayout;
